const MESSENGER = "messenger"
const TRADEIN_OFFER_REQUEST = "tradein_offer_request"
const APPOINTMENT_BOOKING = "appointment_booking"

class ApplicationsService {
  static get MESSENGER() {
    return MESSENGER
  }
  static get TRADEIN_OFFER_REQUEST() {
    return TRADEIN_OFFER_REQUEST
  }
  static get APPOINTMENT_BOOKING() {
    return APPOINTMENT_BOOKING
  }
}

export default ApplicationsService
